import React from "react";
import { BoxIcon } from "lucide-react";
type HrStatCardProps = {
  label: string;
  value: string | number;
  icon: BoxIcon;
  tone?: 'blue' | 'emerald' | 'amber' | 'red' | 'violet' | 'slate' | 'pink' | 'teal';
  hint?: string;
  emphasis?: boolean;
};
const tones = {
  blue: 'bg-blue-50 text-blue-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  red: 'bg-red-50 text-red-600',
  violet: 'bg-violet-50 text-violet-600',
  slate: 'bg-slate-100 text-slate-600',
  pink: 'bg-pink-50 text-pink-600',
  teal: 'bg-teal-50 text-teal-600'
};
export function HrStatCard({
  label,
  value,
  icon: Icon,
  tone = 'blue',
  hint,
  emphasis
}: HrStatCardProps) {
  return <div className={`flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm ${emphasis ? 'sm:col-span-2' : ''}`} data-id="element-1090" data-mp="2h9eelst6ddf1">
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${tones[tone]}`} data-id="element-1091" data-mp="10umknbgdry3m">
        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-1092" data-mp="15sxsjgn47yj7" />
      </span>
      <div className="min-w-0" data-id="element-1093" data-mp="1dvfv339egn3a">
        <p className="text-xs font-medium text-slate-500" data-id="element-1094" data-mp="1dwr016el00vz">{label}</p>
        <p className={`truncate font-bold tabular-nums text-slate-900 ${emphasis ? 'text-2xl' : 'text-lg'}`} data-id="element-1095" data-mp="19ue4fatjtjcx">{value}</p>
        {hint && <p className="truncate text-xs text-slate-500" data-id="element-1096" data-mp="1nqrcxug3uaf9">{hint}</p>}
      </div>
    </div>;
}